export default __webpack_public_path__ + "static/media/slide-cell-1.26776e20.svg";